import { useState } from 'react'
import { AboutSection } from '../../features/AboutSection'
import { BenefitsSection } from '../../features/BenefitsSection'
import { ContactSection } from '../../features/ContactSection'
import { DetailsSection } from '../../features/DetailsSection'
import { FeaturesSection } from '../../features/FeaturesSection'
import { GallerySection } from '../../features/GallerySection'
import { HeroSection } from '../../features/HeroSection'
import HeroBooking from '../../features/HeroSection/ui/HeroBooking/HeroBooking'
import { PriceSection } from '../../features/PriceSection'
import { ReviewsSection } from '../../features/ReviewsSection'
import { usePageContent } from '../../shared/lib/hooks/usePageContent/usePageContent'
import { StickyHeader } from '../../shared/ui/StickyHeader'

export const MainPage = () => {
    usePageContent()
    const [bookingOpen, setBookingOpen] = useState(false)

    return (
        <>
            <StickyHeader onPrimaryCtaClick={() => setBookingOpen(true)} />
            <HeroSection />
            <BenefitsSection />
            <GallerySection />
            <AboutSection />
            <PriceSection />
            <DetailsSection />
            <FeaturesSection />
            <ReviewsSection />
            <ContactSection />
            <HeroBooking open={bookingOpen} onClose={() => setBookingOpen(false)} />
        </>
    )
}
